import LazyInView from '../shared/LazyLoad/Lazy/LazyInView';

const LegacyStyledComponentsPage: FC = ({ children }) => (
  <LazyInView>{children}</LazyInView>
);

export default LegacyStyledComponentsPage;
